import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';
      
class PurchaseButtonInfov585Task extends AbstractRequestTask {
  constructor(params) {    
    super();    
    this.groupId = params.groupId;
    this.seasonId = params.seasonId;
    this.validateLogin = params.validateLogin || false;
  }

  getHeaders() {
    const params = super.getParams();
    const headers = {
      'Content-Type': 'application/json',
    };
    if(params.user_token) {
        headers["user-token"] = params.user_token;
    }
  
    return headers;
  }

    getUrl() {
      const http = "https://";
      const url = Launcher.get("akamai_mfwk");
      return `${http}${url}/services/payway/v1/purchasebuttoninfo`;
    }

    getParams() {
      const params = super.getParams();
      delete params.HKS;
      delete params.user_token;
      delete params.api_version;
      return {
        group_id: this.groupId,
        season_id: this.seasonId,
        validatelogin: this.validateLogin,
        ...params,        
    };
    }

    success(data, b) {
      this.resolve(data);
    }

    getShowErrorModal(){
      return ENABLE_MODAL_RETRIES;
    }
  }

export default PurchaseButtonInfov585Task;
               



// WEBPACK FOOTER //
// ./src/requests/tasks/payway/PurchaseButtonInfov585Task.js